// extracted by mini-css-extract-plugin
module.exports = {"title":"e_Kf","container":"e_Lf","right":"e_Mf","image":"e_Nf","scoreLine":"e_Of","scoreRing":"e_Pf","badge":"e_Qf","badgeImage":"e_Rf","badgeRing":"e_Sf","large":"e_Tf"};